'use client'

import { Toaster as HotToaster } from 'react-hot-toast'

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        className: "!text-foreground border",
        style: {
          padding: '16px',
          color: 'var(--foreground)',
          background: '#ffffff',
          border: '1px solid var(--border)',
        },
        success: {
          iconTheme: {
            primary: '#10b981',
            secondary: 'white',
          },
        },
        error: {
          iconTheme: {
            primary: '#ef4444',
            secondary: 'white',
          },
        }
      }}
    />
  )
} 